export enum TreeEvent {
  EXTERNAL_NODE_ATTACHED = 'externalNodeAttached',
  EXTERNAL_NODE_DROPPED_WITH_NO_ATTACH = 'externalNodeDroppedWithNoAttach',
  NODE_CLICKED = 'nodeClicked',
  NODE_DROP_VALIDATION_ERROR = 'nodeDropValidationError',
  NODE_CHECKED = 'nodeChecked',
  NODE_TOGGLED = 'nodeToggled',
  CHANGED_ACTIVE_NODE = 'changedActiveNode', // when clicking outside of icon/text
  LOAD_NEXT_NODES = 'loadNextNodes',
}

export enum TreeDataTransferFormat {
  TEXT = 'text/plain',
}
